export const environment = {
  production: false,
  mockMode: false,
  apiBaseUrl: 'https://appli-back-int.logiciels-carbone14.fr',
  auth: {
    backOfficeUrl: 'https://appli-back-int.logiciels-carbone14.fr',
    authContextPath: '/auth',
    clientId: 'carbone14f',
    clientSecret: 'Partner1',
  },
};
